import { stack as d3_stack } from 'd3-shape'
import { convertRowsToData } from '../utils/dataUtils'

export default function LineChartDataController(rows, config = {}, hiddenItems) {
  let headers = rows[0]
  let propperHeaders = ['id', ...headers.slice(1)]

  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 2)
  if (hiddenItems)
    data.forEach(d => (d.value = d.value.filter(dd => hiddenItems.indexOf(dd.id) < 0)))

  if (config.mode === 'areas') {
    let keys = data.reduce((res, d) => {
      d.value.forEach(dd => res.push(dd.id))
      return res
    }, [])
    keys = keys.filter((value, index, self) => self.indexOf(value) === index)

    let objArray = data.map(layer => {
      let res = { id: layer.id }
      layer.value.forEach(dd => {
        res[dd.id] = dd.value
      })
      return res
    })
    let stack = d3_stack()
      .value((d, key) => d[key])
      .keys(keys)

    let stacked = stack(objArray)
    let result = stacked.map(layer => {
      return {
        id: layer.key,
        index: layer.index,
        value: layer.map(dd => {
          return {
            id: dd.data.id,
            value: dd.data[layer.key],
            y0: dd[0],
            y1: dd[1],
            layerIndex: layer.index,
            isLastLayer: keys.indexOf(layer.key) === keys.length - 1,
            isFirstLayer: keys.indexOf(layer.key) === 0,
            parentId: layer.key,
          }
        }),
      }
    })
    return result
  } else {
    let keys = data.reduce((res, d) => {
      d.value.forEach(dd => res.push(dd.id))
      return res
    }, [])
    keys = keys.filter((value, index, self) => self.indexOf(value) === index)

    let res = keys.map(key => {
      let keyValues = data.map(dd => {
        let cand = dd.value.find(ddd => ddd.id === key)
        return {
          id: cand.parentId,
          parentId: cand.id,
          value: cand.value,
        }
      })
      if (config.interpolateLine) keyValues = keyValues.filter(d => !!d.value || d.value === 0)
      return {
        id: key,
        value: keyValues,
      }
    })
    return res
  }
}
